import { render, staticRenderFns } from "./Lungcancer502.vue?vue&type=template&id=2d2c4c1a&scoped=true&"
import script from "./Lungcancer502.vue?vue&type=script&lang=js&"
export * from "./Lungcancer502.vue?vue&type=script&lang=js&"
import style0 from "./Lungcancer502.vue?vue&type=style&index=0&id=2d2c4c1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c4c1a",
  null
  
)

export default component.exports